import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { MaskLines } from "./Primitives";

export const PageHero = ({ eyebrow, lines, intro, image, children, testId = "page-hero" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", reduce ? "0%" : "18%"]);
  return (
    <section ref={ref} className="grain relative isolate overflow-hidden bg-navy pb-20 pt-36 md:pb-28 md:pt-44" data-testid={testId}>
      {image && (
        <motion.div className="absolute inset-0 -z-10" style={{ y }}>
          <img src={image.src} alt="" className="h-[120%] w-full object-cover opacity-35" style={{ objectPosition: image.position || "center" }} />
        </motion.div>
      )}
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-navy via-navy/90 to-navy/40" />
      <div className="container-x">
        {eyebrow && <p className="eyebrow eyebrow-light">{eyebrow}</p>}
        <h1 className="mt-6 max-w-5xl text-4xl font-black uppercase leading-[1.02] tracking-tight text-paper sm:text-5xl lg:text-7xl">
          <MaskLines lines={lines} />
        </h1>
        {intro && (
          <motion.p
            className="mt-8 max-w-2xl text-base leading-relaxed text-[#D5DEE7] md:text-lg"
            initial={reduce ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
          >
            {intro}
          </motion.p>
        )}
        {children}
      </div>
      {image?.caption && <span className="absolute bottom-4 right-4 hidden max-w-xs text-right text-[11px] text-[#C9D4DF] md:block">{image.caption}</span>}
    </section>
  );
};
